import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import L from 'leaflet'; // eslint-disable-line
import { Polygon } from 'react-leaflet';

const EditFieldPoints = (props) => {
  const { field, map, polyRef } = props;
  const [latLngs, setLatLngs] = useState();

  useEffect(() => {
    if (latLngs === undefined) {
      if (field && field.geometry?.coordinates?.length > 0) {
        const l = [];
        if (field.geometry.type === 'Polygon') {
          _.forEach(field.geometry?.coordinates[0], (c) => {
            if (c !== undefined) {
              l.push([c[1], c[0]]);
            }
          });
        } else if (field.geometry.type === 'MultiPolygon') {
          for (let i = 0; i < field.geometry.coordinates.length; i++) {
            const region = [];
            _.forEach(field.geometry.coordinates[i][0], (c) => {
              region.push([c[1], c[0]]);
            });
            l.push(region);
          }
        }
        setLatLngs(l);
      }
    }
  }, [field]); // eslint-disable-line

  useEffect(() => {
    if (polyRef?.current) {
      if (field.editPolygon) {
        polyRef.current.enableEdit();
      } else {
        polyRef.current.disableEdit();
      }
    }
  }, [field.editPolygon]); // eslint-disable-line

  useEffect(() => {
    if (field.draw) {
      map?.editTools.startPolygon();
    }
  }, [field.draw]); // eslint-disable-line

  return !_.isEmpty(latLngs) && !field.draw ? <Polygon ref={polyRef} id="field1" positions={latLngs} /> : null;
};

EditFieldPoints.propTypes = {
  field: PropTypes.object,
  map: PropTypes.object,
  polyRef: PropTypes.object,
};

EditFieldPoints.defaultProps = {
  field: undefined,
  map: undefined,
  polyRef: undefined,
};

export default EditFieldPoints;
